import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { BaseError } from '@data/base/base-error.type';
import { ErrorType } from '@data/domain/enums/error-type';
import { LoadingService } from '@shared/services.loading';
import { GetContentDto, GetContentResp } from '@usecase/content/get-content.interface';
import { GetContentUsecase } from '@usecase/content/get-content.usecase';
import { ITEM } from '@utils/constants';
import { catchError, finalize, Observable, shareReplay, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class LandingResolver implements Resolve<GetContentResp> {
    private readonly getContentUsecase = inject(GetContentUsecase);
    private readonly router = inject(Router);
    private readonly loadingService = inject(LoadingService);

    resolve(route: ActivatedRouteSnapshot): Observable<GetContentResp> {
        const contentType = route.params['content'];
        const payload: GetContentDto = {
            data: contentType
        };
        this.loadingService?.show();

        return this.getContentUsecase.execute(payload).pipe(
            catchError((error: BaseError) => {
                this.loadingService?.hide();
                this.router.navigate([`error/${ErrorType.NOT_FOUND}`]);
                return throwError(() => error);
            }),
            finalize(() => this.loadingService?.hide()),
            shareReplay(ITEM.SINGLE_EMISSION)
        );
    }

}